module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/33bf0f35b15bb242da26a789453bef51.png";